/**
 * Defines the HTML for product images
 * @param {Object} product
 */

const defineHTMLForProductImages = product => {
    const maxDotsInRow = 10;
    const {quickViewImages, productName, fallbackImage, id} = product;
    let productImagesHTML;

    if (quickViewImages && quickViewImages.length > 1) {
        productImagesHTML = `
            <div id="pdpCarousel-${id}" class="pdp-images-carousel img-container hidden-before-init d-flex-before-init${quickViewImages.length > maxDotsInRow ? " multiple-rows-dots" : ""}" data-confirmation-image='${product.confirmationImage ? JSON.stringify(product.confirmationImage) : ""}'>
        `;
    } else {
        productImagesHTML = `
            <div class="img-container" data-confirmation-image='${product.confirmationImage ? JSON.stringify(product.confirmationImage) : ""}'>
        `;
    }

    if (quickViewImages && quickViewImages.length) {
        quickViewImages.forEach(element => {
            let {alt, url, title} = element;
            productImagesHTML += `
                <div class="pdp-carousel-item d-flex justify-content-center">
                    <img alt="${alt}" src="${url}" title="${title}"
                        onerror="this.onerror=null;this.src='${fallbackImage}';"
                        class="ct-product-image ct-product-image--quickview"/>
                </div>
            `;
        });
    } else {
        productImagesHTML +=`
            <img alt="${productName}" src="${fallbackImage}" title="${productName}" class="ct-product-noimage" onerror="this.onerror=null;this.src='${fallbackImage}';"/>
        `;
    }

    productImagesHTML += `
        </div>
    `;

    return productImagesHTML ;
};

export { defineHTMLForProductImages };
